import React from 'react';
import ContactDetailsForm from '../components/contactDetails/contactDetailsForm';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import { track } from 's2s-app-service';
import useContacts from '../hooks/contacts';

const ContactEditContainer = styled.div`
`;

const ContactEdit = injectIntl((props) => {

  const [, , , { addContact, updateContact }] = useContacts();

  const handleSave = async (contact, isNew) => {
    track("contact edit save details", "clicked");

    //  NOTE : Setting data.uuid so updateContact can update...for some reason it is not getting updated uuid?? 
    if (isNew === "add") {
      //console.log('ADDING CONTACT', isNew, contact);
      if (contact.name && contact.name.last !== "") { // NOTE : AppService does not like empty last name field and will error out on blur of first name field    
        addContact(contact, props.intl);
        props.history.replace(`/contacts`);
      }

    } else {
      // console.log('UPDATING CONTACT', contact );
      if (props.match.params.id !== undefined) {
        contact.uuid = props.match.params.id;
      }

      await updateContact(contact, props.intl);
      props.history.replace(`/contacts/${contact.uuid}`);

    }
  };

  const handleCancel = () => {
    track("contactEdit cancel", "clicked");

    if (props.match.params.id !== "new") {
      // we are EDITING a contact, when user cancels, we'd like to go to contact route
      props.history.replace(`/contacts/${props.match.params.id}`);
    } else {
      // we are ADDING a contact, when user cancels, we'd like to go to contactList route 
      props.history.replace('/contacts');
    }
  };

  const validatePhoneNumber = (number) => {
    //console.log('bbbbb');
    return number && number.length === 10;
  };

  return (
    <ContactEditContainer className='ContactEditContainer' >
      <ContactDetailsForm
        cbSaveDetails={handleSave}
        cbPhoneNumberValidation={validatePhoneNumber}
        contactUUID={props.match.params.id}
        isNewContact={props.match.params.id === "new"}
        cbCancelDetailEdit={handleCancel}
      />
    </ContactEditContainer>
  );

});

export default ContactEdit;
